
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('education')
export default {
  name: 'MentorTabs',

  props: {
    selectedTab: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState(['mentor']),

    tabs() {
      return this.mentor?.block?.tabs || []
    },

    tabsAsObject() {
      return this.tabs?.reduce((a, v) => ({ ...a, [v.type]: v }), {})
    },

    selectedTabAttendees() {
      const tab = this.tabsAsObject[this.selectedTab]
      if (!tab) {
        return []
      }

      const mentorCourses =
        tab.contentCourses.map(course => this.mentor?.courses[course]) || []
      const mentorStreams =
        tab.contentStreams.map(course => this.mentor?.streams[course]) || []
      const mentorStudyGroups =
        tab.contentStudyGroups.map(
          course => this.mentor?.studyGroups[course]
        ) || []

      return [...mentorCourses, ...mentorStreams, ...mentorStudyGroups]
    }
  }
}
